<button mat-icon-button  mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<a (click)="preBook()" fxHide.xs>
  <img src="assets/tfresh/images/popup.jpg"alt="">
</a>
<a (click)="preBook()"fxHide.gt-xs>
  <img src="assets/tfresh/images/popup-mobile.jpg" alt="">
</a>
